import { Form, Input, Button, notification, DatePicker, Space, Divider } from 'antd';
import { NavLink, useHistory } from 'react-router-dom';
import { MinusCircleOutlined, PlusOutlined } from '@ant-design/icons';
import moment from "moment"
import useResumeService from '../../../../../../service/hooks/useResumeService'

const { RangePicker } = DatePicker;

function ProjectExperienceForm() {
  const history = useHistory();
  const service = useResumeService();
  const data = service.project;
  const urlInfo = service.urlInfo.project;

  const onFinish = (values) => {
    console.log('Success:', values);
    
    service.postData('project_experience', 
      values.projects.map(value => ({
        ...value,
        duration: value.duration.map(time => time.format('YYYY-MM-DD'))
      }))
    ).then(() => {
      history.location.search === '?type=complete' ? history.push(urlInfo.urlAfterSave) : history.push('/user/center/my-resume/view');
    })
  };

  return(
  <>
    <p
      style={{
        color: 'rgb(19, 61, 177)',
        fontSize: '16px'
      }}
    >
      请从最新的项目写起，这才是HR最想看到的！
    </p>
    <Form
      key="project"
      name="project"
      initialValues={data ?
        {
          projects: data.map(item => ({
            ...item,
            duration: [moment(item.duration[0], 'YYYY-MM-DD'), moment(item.duration[1], 'YYYY-MM-DD')]
          }))
        }:
        {projects: [{}]}
      }
      onFinish={onFinish}
      onFinishFailed={()=>notification.warn({ message: '格式错误', description: '请检查表单内容', key: 'form error'})}
    >

      <Form.List name="projects">
        {(fields, { add, remove }) => (
          <>
            {fields.map(({ key, name, ...restField }) => (
              <>
                {console.log(key, name, restField)}
                {name > 0 && 
                  <MinusCircleOutlined
                    onClick={() => remove(name)}
                    style={{
                      fontSize: '20px',
                      color: '#909090'
                    }}
                  />
                }

                <Form.Item
                  {...restField}
                  label="项目名称"
                  name={[name, "projectName"]}
                  labelCol={{ span: 4 }}
                  wrapperCol={{ span: 16 }}
                  rules={[{ required: true, message: '请输入项目名称!' }]}
                >
                  <Input />
                </Form.Item>

                <Form.Item
                  {...restField}
                  label="项目时间"
                  name={[name, "duration"]}
                  labelCol={{ span: 4 }}
                  wrapperCol={{ span: 16 }}
                  rules={[{ required: true, message: '请输入项目时间!'}]}
                >
                  <RangePicker />
                </Form.Item>

                <Form.Item
                  {...restField}
                  label="项目内容"
                  name={[name, "description"]}
                  labelCol={{ span: 4 }}
                  wrapperCol={{ span: 16 }}
                >
                  <Input.TextArea
                    showCount
                    maxLength={300}
                    autoSize
                    placeholder='描述你的参与内容、项目成果'
                  />
                </Form.Item>
                
                <Divider />
              </>
            ))}
            <Form.Item>
              <Button type="dashed" onClick={() => add()} block icon={<PlusOutlined />}>
                添加项目
              </Button>
            </Form.Item>
          </>
        )}
      </Form.List>

      <Form.Item wrapperCol={{ offset: 7, span: 16 }}>
        <Space>
          <NavLink to='/user/center/my-resume/view'>
            <Button>
              取消
            </Button>
          </NavLink>
          <Button type="primary" htmlType="submit">
            保存{history.location.search === '?type=complete' ? '并进入下一项' : '并返回'}
          </Button>
        </Space>
      </Form.Item>
    </Form>
  </>
  );
}

export default ProjectExperienceForm;